import { z } from "zod";

export const MappingReferenceDatasetSchema = z
  .object({
    id: z.string().min(1),
    label: z.string().min(1),
    sourceKind: z.enum(["AIRE_PACKAGE", "REVIEWED_FIAR_SNAPSHOT", "FINANCE_DECISION"]),
    sourceReference: z.string().min(1),
    sourceUrl: z
      .string()
      .url()
      .regex(/^https:\/\/(github\.com\/LIO-Insurance\/|lioinsurance\.atlassian\.net\/browse\/)/u)
      .optional(),
    note: z.string().min(1),
    columns: z.array(z.string().min(1)).min(1),
    rows: z.array(z.record(z.string())),
  })
  .superRefine((dataset, ctx) => {
    if (
      new Set(dataset.columns).size !== dataset.columns.length ||
      dataset.rows.some(
        (row) =>
          Object.keys(row).length !== dataset.columns.length ||
          dataset.columns.some((column) => typeof row[column] !== "string"),
      )
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Mapping columns and row values must match",
      });
    }
  });

export const MappingReferenceResponseSchema = z.object({
  datasets: z.array(MappingReferenceDatasetSchema),
});

export type MappingReferenceDataset = z.infer<typeof MappingReferenceDatasetSchema>;
export type MappingReferenceResponse = z.infer<typeof MappingReferenceResponseSchema>;
